<script>
    import { t, locale, locales } from "../../../scripts/i18n";

    export let stage = {};
    export let setStage;

</script>

<div class="banner-wrap">
    <div class="banner-intro">
        {$t('Scan completed successfully. You can now start cleaning your account from ghosts')}
    </div>

    <div class="btn-wrap">
        <a href="/demo/analyze-finished" class="pulse-button mx-auto purple-btn purple-btn_hover w-190px h-45px">
            {$t('Cleaning settings')}
        </a>
    </div>
</div>